
<div>
  <div class="lv-meta-links fds">
    <p class="desc mb-0">
      <icon glyph="related-object" class="mr-2" aria-hidden="true"></icon>
      {{hasEntryRelation ? "1" : "0"}} record{{hasEntryRelation ? "" : "s"}} (limit 1)
    </p>
    <p v-if="shouldShowSearchDropdown" class="desc">
      <button
        id="selection-title"
        class="btn-link"
        data-toggle="collapse"
        :data-target="`#selections-${relationSectionRelation.client_id}`"
        aria-expanded="false"
        aria-controls="selections">
        {{ searchText }}
        <icon glyph="arrow-chevron" tag="small" aria-hidden="true"></icon>
      </button>
    </p>
    <p v-if="shouldShowDisconnect" class="desc">
      <button
        class="btn-link"
        @click="showDisconnectModal">
        Disconnect Record
      </button>
    </p>
    <p class="desc mb-0" v-if="shouldShowLinkToView">
      <a :href="detailViewLink" class="btn-link">View Record<icon glyph="open-file" class="ml-2" tag="small" aria-hidden="true"></icon></a>
    </p>
  </div>

  <div :id="`selections-${relationSectionRelation.client_id}`" class="collapse" :aria-labelledby="`selection-title-${relationSectionRelation.client_id}`">
    <a-select
      v-if="shouldShowObjectModelSelect"
      :id="`object-model-select-${relationSectionRelation.client_id}`"
      :options="objectModelOptions"
      @input="updateObjectModelId"
      placeholder="Choose object model"
    />

    <a-select
      :id="relationSectionRelation.client_id"
      compress
      :options="entryOptions(relationSectionRelation)"
      @input="entryId => onSelectEntry(relationSectionRelation, entryId)"
      @search:finished="addEntriesToRepo"
      :disabled="shouldDisableEntrySearch"
    />
  </div>

  <layout-element-grid
    v-if="shouldShowRelationSection"
    :content-element="contentElement"
    :entry="entry"
    :is-in-edit-mode="isInEditMode"
    :key="contentElement.client_id"
  ></layout-element-grid>

  <confirmation-modal
    v-if="modalStateFor(vueModalID.relationSectionDisconnect).isVisible"
    :state="modalStateFor(vueModalID.relationSectionDisconnect)"
    :index="vueModalID.relationSectionDisconnect"
    @toggle-modal="hideModal(vueModalID.relationSectionDisconnect)"
    @affirm-cta="disconnectRecord"
    :override-config="disconnectModelConfig"
  ></confirmation-modal>
</div>
